import React from "react";
import { InlineLoading } from "../LoadingOverlay";
import NormalRounds from "./NormalRounds";
import WeekendRounds from "./WeekendRounds";
import AssistantNurseRounds from "./AssistantNurseRounds";
import TeacherCertRounds from "./TeacherCertRounds";
import GraduateRounds from "./GraduateRounds";
import "./RegisterRounds.css";

/**
 * ============================================================================
 * ส่วน "เลือกรอบที่ต้องการสมัคร" ของหน้า /Register/:param
 * ============================================================================
 * param คือประเภทนักศึกษาที่ส่งมาจากหน้าแรก — หนึ่ง param หนึ่ง component
 *
 *   0 → AssistantNurseRounds  ประกาศนียบัตรบัณฑิต สาขาผู้ช่วยพยาบาล
 *   1 → NormalRounds          ปริญญาตรี ภาคปกติ + พยาบาลศาสตรบัณฑิต
 *   2 → WeekendRounds         ปริญญาตรี ภาค กศ.บป.
 *   3 → GraduateRounds        ปริญญาโท
 *   4 → GraduateRounds        ปริญญาเอก
 *   5 → TeacherCertRounds     ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
 *
 * เพิ่มประเภทใหม่ = เพิ่มไฟล์ component แล้วเพิ่ม case ที่นี่
 * ไม่ต้องไปแก้ JSX ในหน้า Register อีก
 * ========================================================================= */
function RegisterRounds({ param, loading, rounds, selectedRobId, onSelect }) {
  if (loading) {
    return <InlineLoading label="กำลังโหลดรอบรับสมัคร..." />;
  }

  const shared = { rounds, selectedRobId, onSelect };

  switch (String(param)) {
    case "0":
      return <AssistantNurseRounds {...shared} />;
    case "1":
      return <NormalRounds selectedRobId={selectedRobId} onSelect={onSelect} />;
    case "2":
      return <WeekendRounds {...shared} />;
    case "3":
    case "4":
      return <GraduateRounds {...shared} />;
    case "5":
      return <TeacherCertRounds {...shared} />;
    default:
      return <p className="reg-empty">ยังไม่มีรอบเปิดสมัครเรียน</p>;
  }
}

export default RegisterRounds;
export {
  NormalRounds,
  WeekendRounds,
  AssistantNurseRounds,
  TeacherCertRounds,
  GraduateRounds,
};
